import {useContext} from 'react';
import ColorMastersContext from './color-masters-context';

const useColorMasters = () => {
  const context = useContext(ColorMastersContext);
  return context
};

export default useColorMasters;
